/*
 * Помощь с паролем: генерация и оценка стойкости.
 *
 * Основной режим — парольная фраза из случайных слов. Причина простая:
 * пароль от мессенджера набирают на телефоне, и `xK9#mP2$vL` там либо
 * не наберут, либо запишут на бумажке рядом с устройством. Фраза из
 * пяти слов даёт сопоставимую стойкость и при этом произносима.
 *
 * Второй режим — случайные символы, для тех, у кого менеджер паролей.
 *
 * Энтропия считается от фактического размера словаря после удаления
 * дублей: если я случайно повторю слово, оценка снизится сама, а не
 * останется завышенной.
 */

// Короткие, легко произносимые и однозначно пишущиеся слова.
// Без «ё», без слов с плавающим написанием.
const RAW_WORDS = `
акула алмаз апрель арбуз архив астра атлас бабочка багаж базар балкон банан барабан
башня бегун берег беседа бетон билет бинокль блокнот болото ботинок браслет бревно
бригада бронза брошка брызги буква букет булава бумага бутон буфет вагон валенок
ванна варенье ведро веник ветер вечер вешалка взгляд вилка виноград вишня влага
вода водопад возраст вокзал волна ворота восход впадина время всадник вулкан выбор
выдра выставка вышка газета галерея галстук гараж гвоздика гейзер герой гитара глина
глобус говор голубь гора горизонт город горох гость гравий гранат граница гриб гроза
группа груша грядка губка гусеница гусли дача двери дельфин дерево деталь диван
диктант динамо диплом директор дневник дождь доклад доктор долина домик дорога доска
дракон дрова дружба дуб дыня дятел единица ежевика елка желудь железо жемчуг жираф
журавль забор завод загадка задача закат замок заря заяц звезда зверь здание зебра
зелень земля зеркало зерно зима знамя золото зонтик зубр игла игра идея избушка
икона искра история кабина кактус календарь калина камень камыш канал капель капуста
карандаш карета карман карта картина каскад катер качели каша каюта квартал кедр
кисель кисть клавиша клен клубок ключ книга ковер кожа колесо колодец колокол колонна
комар комета комната компас конверт конус копыто корабль корзина корень коржик корица
корова коса костер котел кофе кошка краска кратер кресло кристалл крокус кролик крона
круг крыло крыша кувшин кузнец кукла кулак купол курага курорт куст лаванда лагерь
ладонь лампа ландыш лапша ласточка лебедь лента лепесток лес лестница лето линза
лиса листва лодка ложка локоть лопата лось луг луна лупа лыжи любовь люстра лягушка
магнит майка макет малина мандарин манеж маска масло матрос машина маяк мебель мед
медведь мелодия месяц металл метель метро мешок минута мираж мишень мозаика молния
молоко монета море морковь мороз мост мотор мрамор муравей музей мысль мышь мятеж
набат наволочка награда надежда налим напиток народ насос натура невод нектар нерпа
низина нитка ножницы нора носорог ночь нуга оазис облако обруч обувь овес овраг овца
огонь огурец одеяло озеро океан окно олень олива опушка орбита орех оркестр осень
осина остров отвага открытка охота очаг ошейник пакет палатка палец пальма панама
папка парад парус пастух паук паутина пахота пейзаж пекарь пенал перо перрон персик
песок петля печенье пещера пирог письмо пихта планета пластина платок плечо плита
плот площадь победа поезд пожар поле полет полка полночь помидор порог портфель
посуда поток почта пояс правда праздник провод прогулка простор прыжок пустыня путник
пшеница пчела пыльца пятно радуга разговор ракета раковина рама растение ребус река
рельс ремень репа ресница решето рисунок робот рожь роза роса рояль рубанок рубеж
ручей рыба рынок рябина сабля садовник салат самолет сани сапог сарай свеча свисток
север седло секунда сельдь семечко сено сердце серебро сестра сеть сигнал сирень
сказка скала скамейка скворец складка скрипка слива слово слон случай смородина снег
собака совет сокол солнце соловей соль сосна сосуд спектр спица спутник среда стакан
станок статуя стебель стекло стена степь стойка стол столица страна стрела стриж
строка струна ступень стул сугроб сумка суша схема сцена счеты сыр табак тайга тайна
талант танец тарелка театр тележка телефон тень терем тесто тетрадь тигр тишина ткань
товар топор торт травинка трактор трамвай тропа труба тюлень тюльпан туман туча тыква
тюбик увалень угол удача узел улей улица улитка утес утро ухват учебник фазан факел
фартук фасоль февраль фиалка фигура филин фонарь фонтан форель фрегат фрукт футляр
хвоя хижина хлеб хлопок хмель холм хомяк хорек храм хребет хрусталь цапля цветок
цепочка циркуль цитата чайка чайник часовня чашка человек черемуха череп чертеж
чеснок чехол числа читатель чудо чулан шалаш шампунь шапка шарф шатер шахта швея
шелест шелк шеренга шиповник ширина шишка школа шкатулка шлюпка шляпа шнурок шоколад
шорох шпага штора штурман шуба шум щавель щегол щетка щука экипаж экран экскурсия
эмблема энергия эскиз этаж эхо юбилей юмор юноша якорь янтарь ярмарка ясень яхта
ячмень ящерица ящик
`;

// Дубли молча снижают энтропию, поэтому убираем их и считаем от факта
const WORDS = [...new Set(
  RAW_WORDS.split(/\s+/).map((w) => w.trim()).filter(Boolean)
)];

const SYMBOL_ALPHABET = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789!@#$%^&*-_=+';

/*
 * Семь слов, а не пять.
 *
 * Словарь на ~600 слов даёт ~9,3 бита на слово. Пять слов — это 46 бит,
 * то есть ровно на границе, которую этот же модуль называет слабой.
 * Генератор по умолчанию обязан уверенно проходить собственную планку,
 * поэтому семь: около 65 бит.
 */
const DEFAULT_WORD_COUNT = 7;
const DEFAULT_SYMBOL_LENGTH = 20;

export function getWordlistSize() {
  return WORDS.length;
}

// Равномерный выбор без смещения по модулю
function randomIndex(bound) {
  const limit = Math.floor(0xffffffff / bound) * bound;
  const buffer = new Uint32Array(1);

  let value;
  do {
    crypto.getRandomValues(buffer);
    value = buffer[0];
  } while (value >= limit);

  return value % bound;
}

function randomFrom(list) {
  return list[randomIndex(list.length)];
}

export function generatePassphrase(wordCount = DEFAULT_WORD_COUNT) {
  const count = Math.max(3, Math.min(Number(wordCount) || DEFAULT_WORD_COUNT, 10));
  const words = [];
  for (let i = 0; i < count; i += 1) words.push(randomFrom(WORDS));

  // Дефис вместо пробела: не съедается копированием и виден целиком
  return words.join('-');
}

export function generateSymbolPassword(length = DEFAULT_SYMBOL_LENGTH) {
  const size = Math.max(12, Math.min(Number(length) || DEFAULT_SYMBOL_LENGTH, 64));
  let out = '';
  for (let i = 0; i < size; i += 1) out += randomFrom(SYMBOL_ALPHABET);
  return out;
}

/*
 * Оценка стойкости.
 *
 * Для сгенерированных нами паролей энтропия известна точно. Для набранных
 * руками её приходится оценивать — и оценка заведомо оптимистичная:
 * «пароль123» по формуле выйдет приличным, хотя ломается мгновенно.
 * Поэтому отдельно ловим очевидно слабые случаи и режем оценку.
 */
const WEAK_PATTERNS = [
  /^(.)\1+$/,                        // одна буква повторами
  /^(?:0123|1234|2345|abcd|qwer|йцук|asdf|фыва)/i,
  /^(?:password|passwd|пароль|qwerty|йцукен|admin|letmein|welcome)/i
];

// Проверка нужна до вычисления knownExactly ниже по коду
function knownExactlyEarly(allFromWordlist, generated) {
  return allFromWordlist || generated;
}

function alphabetSize(password) {
  let size = 0;
  if (/[a-z]/.test(password)) size += 26;
  if (/[A-Z]/.test(password)) size += 26;
  if (/[а-я]/.test(password)) size += 32;
  if (/[А-Я]/.test(password)) size += 32;
  if (/[0-9]/.test(password)) size += 10;
  if (/[^a-zA-Zа-яА-Я0-9]/.test(password)) size += 20;
  return size || 1;
}

/*
 * generated — признак того, что пароль выдал этот же модуль.
 * Тогда энтропия известна точно и потолок для ручного ввода не нужен.
 */
export function estimateStrength(password, { generated = false } = {}) {
  const value = String(password || '');

  if (!value) {
    return { bits: 0, level: 'empty', label: '', hint: '' };
  }

  // Фраза из нашего словаря: считаем честно по количеству слов
  const parts = value.split('-').filter(Boolean);
  const allFromWordlist = parts.length >= 3 && parts.every((p) => WORDS.includes(p));

  let bits = allFromWordlist
    ? parts.length * Math.log2(WORDS.length)
    : value.length * Math.log2(alphabetSize(value));

  /*
   * Эвристики по символам применимы только к набранному руками.
   *
   * У словарной фразы энтропия известна точно, а повторы букв в ней
   * неизбежны: «цапля-перрон-учебник» — это 45 символов на 20 уникальных.
   * Штраф за это срезал честные 65 бит до 54 и делал собственный
   * генератор «средним» по собственной же шкале.
   */
  if (!knownExactlyEarly(allFromWordlist, generated)) {
    const uniqueRatio = new Set(value).size / value.length;
    if (uniqueRatio < 0.5) bits *= uniqueRatio * 2;
    if (WEAK_PATTERNS.some((re) => re.test(value))) bits = Math.min(bits, 20);
  }

  /*
   * Для ручного ввода оценка — потолок, а не факт.
   *
   * Посчитать по символам можно только алфавит и длину. Что «мама-мыла-раму»
   * — расхожая фраза, формула не знает и выдаст под 80 бит. Полноценная
   * проверка требует словаря на сотни тысяч фраз (zxcvbn и подобные),
   * что тянуть в это приложение несоразмерно.
   *
   * Поэтому набранному руками не выдаём высшую оценку никогда: пусть тот,
   * кому нужна настоящая стойкость, нажмёт «придумать».
   */
  const HAND_TYPED_CAP = 80;
  const knownExactly = allFromWordlist || generated;
  if (!knownExactly) bits = Math.min(bits, HAND_TYPED_CAP);

  bits = Math.round(bits);

  if (value.length < 8) {
    return { bits, level: 'weak', label: 'Слишком короткий', hint: 'Минимум 8 символов' };
  }
  if (bits < 45) {
    return { bits, level: 'weak', label: 'Слабый', hint: 'Подберут перебором' };
  }
  if (bits < 65) {
    return { bits, level: 'medium', label: 'Средний', hint: 'Сойдёт, но лучше длиннее' };
  }
  if (bits < 90 || !knownExactly) {
    return {
      bits,
      level: 'good',
      label: 'Хороший',
      // Честно говорим, что набранному руками верим на слово
      hint: knownExactly ? '' : 'Оценка приблизительная'
    };
  }
  return { bits, level: 'strong', label: 'Очень стойкий', hint: '' };
}

export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
